module.exports = require('./helpers/bundle-url').getBundleURL('kcN7M') + "logo.c51670a8.svg";